/**
 * WorkspacesPage Messages
 *
 * This contains all the text for the WorkspacesPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.workspaces';

export default defineMessages({
  workspaces: {
    id: `${scope}.workspaces`,
    defaultMessage: 'Workspaces',
  },
  newWorkspace: {
    id: `${scope}.newWorkspace`,
    defaultMessage: 'Workspace',
  },
  newWorkspaceModal: {
    id: `${scope}.newWorkspace`,
    defaultMessage: 'New Workspace',
  },
});
